export default "__VITE_ASSET__d4995b3a__"